function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,138.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 700 l0 -680 400 0 400 0 0 90 0 90 -300 0 -300 0 0 590 0 590 -100 0 -100 0 0 -680z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1050 700 l0 -680 400 0 400 0 0 90 0 90 -300 0 -300 0 0 230 0 230 300 0 300 0 0 90 0 90 -300 0 -300 0 0 175 0 175 298 2 297 3 3 93 3 92 -401 0 -400 0 0 -680z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2958 1253 c-57 -71 -196 -240 -308 -378 -495 -606 -690 -847 -690 -851 0 -2 53 -4 118 -3 l117 0 150 185 c83 102 215 266 295 364 80 98 193 237 253 310 l107 132 0 -496 0 -496 100 0 100 0 0 680 0 680 -69 0 -70 0 -103 -127z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3530 700 l0 -680 95 0 95 0 0 488 c0 269 3 491 6 495 3 3 68 -69 143 -161 75 -93 172 -212 216 -266 44 -54 136 -167 205 -250 69 -83 152 -186 185 -228 l60 -77 73 -1 72 0 0 680 0 680 -100 0 -100 0 0 -497 0 -498 -28 35 c-15 19 -170 210 -346 425 -175 214 -345 423 -377 463 l-59 72 -70 0 -70 0 0 -680z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5040 701 l0 -681 95 0 95 0 0 299 0 299 223 4 c271 5 305 14 403 112 81 81 108 148 108 266 0 118 -27 185 -108 266 -43 43 -78 68 -121 85 -58 23 -70 24 -377 27 l-318 3 0 -680z m649 456 c100 -66 108 -232 16 -305 -49 -39 -92 -46 -285 -47 l-185 0 -3 193 -2 193 208 -3 209 -3 42 -28z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6240 700 l0 -680 400 0 400 0 0 90 0 90 -300 0 -300 0 0 590 0 590 -100 0 -100 0 0 -680z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7210 953 c1 -325 4 -447 15 -508 38 -212 194 -374 416 -431 100 -26 242 -16 344 25 159 62 272 177 324 330 l26 76 3 468 3 467 -101 0 -100 0 0 -453 c0 -373 -3 -462 -15 -504 -69 -232 -389 -315 -594 -153 -35 28 -59 59 -83 107 l-33 68 -3 467 -3 468 -99 0 -100 0 0 -427z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8680 700 l0 -680 95 0 95 0 0 445 c0 245 3 445 8 445 4 0 56 -78 117 -173 60 -94 146 -229 192 -300 l83 -127 69 0 69 0 194 304 193 304 3 -449 2 -449 100 0 100 0 0 680 0 680 -69 0 -69 0 -53 -85 c-30 -46 -146 -231 -259 -409 -113 -179 -208 -326 -211 -326 -4 0 -53 73 -110 163 -56 89 -132 209 -169 267 -37 58 -107 169 -156 247 l-89 143 -67 0 -68 0 0 -680z"
}));

const SvgLeanplum = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1000.000000pt",
  height: "138.000000pt",
  viewBox: "0 0 1000.000000 138.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeanplum, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/leanplum.b8117f63.svg";
export { ForwardRef as ReactComponent };